function CheckIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      role="img"
      aria-label="Yes"
    >
      <path
        d="M22.8103 8.52281L10.7728 20.5603C10.4915 20.8414 10.1101 20.9993 9.71248 20.9993C9.31482 20.9993 8.93344 20.8414 8.65217 20.5603L1.93779 13.8103C1.65699 13.5291 1.49927 13.1479 1.49927 12.7505C1.49927 12.353 1.65699 11.9719 1.93779 11.6906L3.81279 9.81562C4.09391 9.53568 4.47449 9.3785 4.87123 9.3785C5.26797 9.3785 5.64854 9.53568 5.92967 9.81562L9.74998 13.5206L18.8212 4.56094C19.1024 4.2807 19.4832 4.12335 19.8801 4.12335C20.2771 4.12335 20.6579 4.2807 20.939 4.56094L22.8094 6.39281C22.95 6.53219 23.0617 6.69805 23.1379 6.8808C23.2141 7.06356 23.2534 7.2596 23.2535 7.45762C23.2536 7.65563 23.2145 7.85171 23.1384 8.03453C23.0623 8.21735 22.9508 8.38331 22.8103 8.52281Z"
        fill="var(--green-700)"
      />
    </svg>
  );
}

export default CheckIcon;
